import React, { useContext, useState, useMemo } from "react";
import { TableBody, TableRow, TableCell, Tooltip, IconButton, Menu, MenuItem } from "@mui/material";
import { ThemeContext } from "../../../../context/ThemeContext";
import { closeOrder, deleteSLTPOrders } from "../../../../api/request/dashboard/dashboard";
import CloseIcon from "@mui/icons-material/Close";
import '../../../../App.scss'
import usePendingOrderCell from "../../../tablecells/PendingOrderCell";
import toast from 'react-hot-toast';
import Checkbox from '@mui/material/Checkbox';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { deleteOrdersData } from '../../../../store/Slices/orderPositionSlice'
// import useTradeCell from "../../../tablecells/Trade";
import { setEditOrderDetail, setTradeModalOpen } from "../../../../store/Slices/globalSymbolSlice";

export default function Orders() {
    const { darkMode } = useContext(ThemeContext);
    const accountId = localStorage.getItem('accountID');
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [hoveredRow, setHoveredRow] = useState(null);
    const [hoveredCell, setHoveredCell] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const { t } = useTranslation()
    const PendingOrderCell = usePendingOrderCell()
    const { symbols } = useSelector(state => state.watchlist)
    const orders = useSelector((state) => state.orderPosition.orders, shallowEqual);
    const dispatch = useDispatch()
    const [contextMenu, setContextMenu] = useState(null);
    const handleContextMenu = (event, row) => {
        event.preventDefault();
        setContextMenu({
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
            row,
        });
    };

    const handleCloseContextMenu = (event) => {
        setContextMenu(null);
    };
    const handleMouseEnter = (rowIndex, cellIndex) => {
        setHoveredRow(rowIndex);
        setHoveredCell(cellIndex);
    };

    const handleMouseLeave = () => {
        setHoveredRow(null);
        setHoveredCell(null);
    };

    const enrichedOrders = orders.length ? orders?.map(order => {
        const matchingSymbol = Object.values(symbols).find(symbol => Number(symbol.id) === Number(order.symbolId));
        return {
            ...order,
            currentPrice: matchingSymbol?.bid || "N/A"
        };
    }) : [];

    const sortTradeData = [...enrichedOrders].sort((a, b) => {
        if (!sortConfig.key) return 0;
        const valueA = a[sortConfig.key];
        const valueB = b[sortConfig.key];

        if (typeof valueA === 'number' && typeof valueB === 'number') {
            return sortConfig.direction === 'asc' ? valueA - valueB : valueB - valueA;
        }
        if (typeof valueA === 'string' && typeof valueB === 'string') {
            return sortConfig.direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
        }
        return 0;
    });

    const filteredData = sortTradeData
    // .filter((row) =>
    //     PendingOrderCell.some((col) => row[col.dataIndex]?.toString().toLowerCase())
    // );
    const orderSLTP = useSelector(state => state.orderPosition.orderSLTP);

    // console.log("Final Data to Render:", filteredData);
    const combinedData = useMemo(() => {
        const sltpOrders = Array.isArray(orderSLTP) ? orderSLTP : [];
        const merged = [...filteredData, ...sltpOrders];

        return merged.sort((a, b) => {
            if (!sortConfig.key) return 0;
            const valueA = a[sortConfig.key];
            const valueB = b[sortConfig.key];

            if (typeof valueA === 'number' && typeof valueB === 'number') {
                return sortConfig.direction === 'asc' ? valueA - valueB : valueB - valueA;
            }
            if (typeof valueA === 'string' && typeof valueB === 'string') {
                return sortConfig.direction === 'asc'
                    ? valueA.localeCompare(valueB)
                    : valueB.localeCompare(valueA);
            }
            return 0;
        });
    }, [filteredData, orderSLTP, sortConfig]);


    // const allSelected = selectedRows.length === combinedData.length && combinedData.length > 0;
    const handleRowSelect = (rowId) => {
        setSelectedRows((prev) =>
            prev.includes(rowId) ? prev.filter(id => id !== rowId) : [...prev, rowId]
        );
    };

    // const handleSelectAll = () => {
    //     setSelectedRows(allSelected ? [] : combinedData.map(row => row.id));
    // };

    const handleCloseClick = async (rowId = null) => {
        const ordersToClose = rowId !== null ? [rowId] : selectedRows;

        if (ordersToClose.length === 0) {
            toast.error("No orders selected");
            return;
        }

        let successCount = 0;
        let failureCount = 0;

        for (const orderId of ordersToClose) {
            try {
                const selectedRow = combinedData.find(row => row?.id === orderId);
                if (!selectedRow) continue;

                let closeResponse;
                let responseMessage = "";
                // deleteSLTPOrders if positionId exists, else closeOrder
                if (selectedRow.positionId) {
                    const payload = { accountId: Number(accountId), positionId: selectedRow.positionId };
                    closeResponse = await deleteSLTPOrders(payload);
                } else {
                    const payload = { accountId: Number(accountId), id: selectedRow.id };
                    closeResponse = await closeOrder(payload);
                }
                responseMessage = closeResponse?.data?.message || closeResponse?.message || "";
                console.log(responseMessage);

                if (closeResponse.status === 200) {
                    successCount++;
                    dispatch(deleteOrdersData(orderId));

                    toast.success(responseMessage || `Order #${selectedRow.id} has been canceled successfully.`);
                } else {
                    failureCount++;
                    toast.error(responseMessage || `Failed to close order #${selectedRow.id} (${symbols[selectedRow.symbolId]?.name || "Unknown"})`);
                }
            } catch (error) {
                console.error("Error closing order:", error);
                failureCount++;
                const backendMessage = error?.response?.data?.message || error.message || "Unknown error occurred";
                toast.error(`Order #${orderId} failed: ${backendMessage}`);
                console.error("Error closing order:", error);
            }
        }
        console.log(failureCount);

        if (failureCount > 0 && successCount === 0) {
            toast.error(`${failureCount} order(s) failed to close`);
        }

        setSelectedRows([]);
    };



    // const handleSort = (key) => {
    //     setSortConfig((prev) => ({
    //         key,
    //         direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    //     }));
    // };

    // const handleToggleSearchBar = () => {
    //     setShowSearchBar((prev) => {
    //         if (prev) setSearchQuery("");
    //         return !prev;
    //     });
    // }
    // const rowHeight = 35;
    // const headerHeight = 50;
    // const visibleRowCount = combinedData.length;
    // const calculatedHeight = Math.min(visibleRowCount * rowHeight + headerHeight, 400);
    // const TradeCell = useTradeCell()

    const handleEditOrderClick = () => {
        if (contextMenu?.row) {
            dispatch(setEditOrderDetail(contextMenu?.row));
            console.log(contextMenu?.row);

            dispatch(setTradeModalOpen(true));
            handleCloseContextMenu();
        } else {
            toast.error("No order selected.");
            dispatch(setEditOrderDetail(null));

        }
    };


    return (
        <>
            {combinedData.length === 0 ? (null) : (
                // <Paper style={{ height: calculatedHeight, position: 'relative', boxShadow: 'none' }}>
                //     <div style={{ position: "absolute", top: 10, right: 16, zIndex: 1000, display: "flex", alignItems: "center", transition: "width 0.4s ease-in-out", }}>
                //         {!showSearchBar && (
                //             <IconButton onClick={handleToggleSearchBar} sx={{ border: darkMode ? "1px solid #202933" : "1px solid #d5d5d5", borderRadius: "50%", transition: "opacity 0.3s ease-in-out", }}>
                //                 <Search sx={{ fontSize: 18 }} />
                //             </IconButton>
                //         )}
                //         {showSearchBar && (
                //             <Paper sx={{ display: "flex", alignItems: "center", borderRadius: 50, width: "250px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", marginLeft: "8px", padding: "2px 8px", transition: "all 0.3s ease-in-out", backgroundColor: darkMode ? "#202933" : "#d5d5d5" }}>
                //                 <TextField size="small" variant="outlined" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ "& fieldset": { border: "none" }, flex: 1, }} />
                //                 <IconButton onClick={handleToggleSearchBar}>
                //                     <CloseIcon sx={{ fontSize: 15 }} />
                //                 </IconButton>
                //             </Paper>
                //         )}
                //     </div>
                <TableBody>
                    {filteredData.map((row, index) => (
                        <TableRow key={row.id} onContextMenu={(event) => handleContextMenu(event, row)}>
                            <TableCell padding="checkbox" sx={{ border: "none", padding: "5px 5px", backgroundColor: darkMode ? "#151924" : "#fff" }}>
                                <Checkbox checked={selectedRows.includes(row.id)} onChange={() => handleRowSelect(row.id)} sx={{ width: 24, height: 24, "& .MuiSvgIcon-root": { fontSize: 12 }, }} />
                            </TableCell>

                            {PendingOrderCell.map((col, colIndex) => {
                                const isLastVisibleColumn = colIndex === PendingOrderCell.length - 1;

                                return (
                                    <TableCell key={col.dataIndex} onMouseEnter={() => handleMouseEnter(index, colIndex)} onMouseLeave={handleMouseLeave} sx={{ fontSize: "0.8rem", border: "none", padding: "5px 5px", backgroundColor: darkMode ? "#151924" : "#fff", position: "relative", overflow: "hidden", }}>
                                        {col.render ? col.render(row[col.dataIndex], row) : row[col.dataIndex]}

                                        {isLastVisibleColumn && hoveredRow === index && (
                                            <Tooltip title={t("close")} arrow>
                                                <IconButton size="small" sx={{ position: "absolute", top: "50%", right: "5px", transform: "translateY(-50%)", backgroundColor: darkMode ? "#151924" : "#fff", }} onClick={() => handleCloseClick(row?.id)}><CloseIcon sx={{ fontSize: 15 }} /></IconButton>
                                            </Tooltip>
                                        )}
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    ))}
                </TableBody>
                // </Paper>
            )}
            <Menu sx={{ "& .MuiList-root": { padding: 0 } }} open={contextMenu !== null} onClose={handleCloseContextMenu} anchorReference="anchorPosition" anchorPosition={contextMenu ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}>
                <div style={{ backgroundColor: darkMode ? "#262f3f" : "" }}>
                    <MenuItem sx={{ fontSize: 13.5 }} onClick={handleEditOrderClick}>{t('editOrder')}</MenuItem>
                    <MenuItem sx={{ fontSize: 13.5 }} onClick={() => handleCloseClick(contextMenu?.row?.id)}>{t("cancelOrder")}</MenuItem>
                </div>
            </Menu>
        </>
    );
}



